<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.attendance_review'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div v-if="gradeLevels.length === 0" class="flex flex-col mt-5">
            <EmptyState with-icon with-button>
                <template v-slot:button>
                    <AppButton element="InertiaLink" :href="meta.links.import_students" v-if="meta.can.create">
                        {{ $t('messages.import_students') }}
                    </AppButton>
                </template>
            </EmptyState>
        </div>
        <div v-else>
            <GroupSelector :grade-levels="gradeLevels" :user-grade-levels="meta.preferences.user_grade_levels">
                <template v-slot:default="{ filteredGradeLevels }">
                    <div
                        class="mb-2 flex gap-x-2 items-end"
                        v-for="gradeLevel in filteredGradeLevels"
                        :key="gradeLevel.id"
                    >
                        <div v-for="group in gradeLevel.groups" :key="group.id">
                            <div v-if="group.image_path">
                                <img class="w-12 h-12 object-contain mb-1" :src="group.image_path" alt="" />
                            </div>
                            <AppButton element="inertia-link" :href="group.url" desired-action class="">
                                {{ group.name }}
                            </AppButton>
                        </div>
                    </div>
                </template>
            </GroupSelector>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import GroupSelector from '@/components/GroupSelector.vue';

export default {
    components: {
        GroupSelector,
        PanelPage,
        AppButton,
        EmptyState,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'gradeLevels'],
};
</script>
